import React from 'react';
import { connect } from 'react-redux';
import Dialog from 'xgimi-ui/Dialog';
import Button from 'xgimi-ui/Button';
import images from '@/assets/images';
import StoreComponent, { mapStateToProps } from '../../../appComponents/Store';
import s from './.module.scss';

interface Props {
  // 是否打开
  open: boolean;
  // 数据
  data: Record<string, any>[];
  /**
   * 选择
   * @param typeCode 选择后的类型编码
   * @param desc 选择后的类型名称
   */
  onUpdate?: (typeCode: string, desc: string) => void;
  // 关闭回调
  onClose: () => void;
}

interface State {
  // 当前级分类数据
  currentData: Record<string, any>[];
  // 父级分类集合
  parentData: Record<string, any>[][];
  // 父级标题集合
  parentTitle: string[];
  // 点击前进
  onNext: boolean;
  // 点击后退
  onBack: boolean;
  // 当前选择的数据
  currentItem: Record<string, any>;
}

/**
 * 场景编辑
 */
class Component extends StoreComponent<Props, State> {
  state: State = {
    currentData: [],
    parentData: [],
    parentTitle: [],
    onNext: false,
    onBack: false,
    currentItem: {},
  };
  constructor(props: Props) {
    super(props, { languageKey: 'page.feedback', titleKey: 'title' });
  }
  componentDidMount() {
    // --- 监听 ---
    this.watch('data', () => this.props.data, (data) => {
      this.setState({ currentData: data });
    });
  }

  /**
   * 取消
   */
  private onCancel = (): boolean => {
    this.props.onClose();
    return false;
  };

  /**
   * 选择类型后
   * @params item 当前这条数据
   */
  private onNext = (item: Record<string, any>) : void => {
    if (item.lastLevel === 1) {
      this.setState({ currentItem: item, onNext: false });
    } else {
      const parentData = [...this.state.parentData];
      const currentData = [...this.state.currentData];
      const parentTitle = [...this.state.parentTitle];
      parentData.push(currentData);
      parentTitle.push(item.content);
      this.setState({ currentItem: {}, currentData: item.assistTypeResList, parentData, parentTitle, onNext: true });
      setTimeout(() => {
        this.setState({ onNext: false });
      }, 300);
    }
  };

  /**
   * 返回上一级
   */
  private onBack = () : void => {
    const parentData = [...this.state.parentData];
    const currentData = parentData[parentData.length - 1];
    const parentTitle = [...this.state.parentTitle];
    parentData.pop();
    parentTitle.pop();
    this.setState({ currentData, parentData, parentTitle, onBack: true });
    setTimeout(() => {
      this.setState({ onBack: false });
    }, 300);
  };

  /**
   * 确定
   */
  private onConfirm = () : void => {
    const currentItem = this.state.currentItem;
    this.props.onUpdate?.(currentItem.typeCode, currentItem.content);
    this.props.onClose();
  };

  render(): React.ReactNode {
    const parentLength = this.state.parentData.length;
    return (
      <Dialog
        className={s.drawer}
        isOpen={this.props.open}
        isResponsive={true}
        onClose={this.onCancel}
        classes={{ paper: s.dialogPaper, container: s.dialogContainer }}
      >
        <div className={this.getClassName([s.container])}>
          <div className={s.operation}>
            {parentLength > 0 && (
            <div onClick={this.onBack}>
              <img src={images.back} alt="" width={24} height={24}/>
            </div>
            )}
            {parentLength === 0 && (<div style={{ width: '24px' }}/>)}
            <div onClick={this.onCancel}><img src={images.iconError} alt="" width={24} height={24}/></div>
          </div>
          <div className={this.getClassName([s.title])}>问题类型</div>
          {parentLength > 0 && (<div className={s.parentTitle}>{this.state.parentTitle.join('/')}</div>)}
          <div className={this.getClassName([s.list, this.state.onNext && s.duration, this.state.onBack && s.onBack])}>
            {this.state.currentData.map((item, index) => (
              <div className={s.listItem} key={index} onClick={() => this.onNext(item)}>
                <div className={s.content}>{item.content}</div>
                {item.lastLevel === 0 && (
                <img src={images.next} width={16} height={16} alt=""/>
                )}
                {item.lastLevel !== 0 && this.state.currentItem === item && (
                  <img src={images.iconCorrect} width={24} height={24} alt=""/>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className={s.buttonArea}>
          <Button
            color={'#000004'}
            className={s.button}
            disableElevation={true}
            onClick={this.onConfirm}
          >
            确定
          </Button>
        </div>
      </Dialog>
    );
  }
}

export default connect(mapStateToProps)(Component);
